import React, { useEffect, useState, createContext } from 'react';
import { Route, withRouter, useLocation } from 'react-router-dom';
import App from './App';
import { Login } from './pages/Login';
import { Error } from './pages/Error';
import { NotFound } from './pages/NotFound';
import { Access } from './pages/Access';
import  { Redirect } from 'react-router-dom'
import Permissions from './service/permissions/Permissions';
import { Certificates } from './pages/Certificates';

const saved = localStorage.getItem("user");
const initialValue = JSON.parse(saved);

export const permissionContext = createContext();
const permissions = new Permissions;

const AppWrapper = (props) => {

	// const [colorScheme, setColorScheme] = useState('dark')
	const [colorScheme, setColorScheme] = useState('light')
	const [theme, setTheme] = useState('blue');
	const [componentTheme, setComponentTheme] = useState('blue');
	const [rolePermissions,setRolePermissions] = useState(null)

	// console.log(theme);
	let location = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [location]);


    useEffect(()=>{
		 getPermissions() 
		//  onColorSchemeChange('dark')	
	},[])

    const getPermissions = async() =>{
        const res = await permissions.getPermissionsDetails();
        setRolePermissions(res)
    }

	const onColorSchemeChange = (scheme) => {
		changeStyleSheetUrl('layout-css', 'layout-' + scheme + '.css', 1);
		changeStyleSheetUrl('theme-css', 'theme-' + scheme + '.css', 1);
		setColorScheme(scheme);
	}

	const changeStyleSheetUrl = (id, value, from) => {
		const element = document.getElementById(id);
		const urlTokens = element.getAttribute('href').split('/');

		if (from === 1) {           // which function invoked this function - change scheme
			urlTokens[urlTokens.length - 1] = value;
		} else if (from === 2) {       // which function invoked this function - change color
			urlTokens[urlTokens.length - 2] = value;
		}

		const newURL = urlTokens.join('/');
		replaceLink(element, newURL);
	}

	const onMenuThemeChange = (theme) => {
		const layoutLink = document.getElementById('layout-css');
		const href = 'assets/layout/css/' + theme + '/layout-' + colorScheme + '.css';

		replaceLink(layoutLink, href);
		setTheme(theme);
	}

	const onComponentThemeChange = (theme) => {
		const themeLink = document.getElementById('theme-css');
		const href = 'assets/theme/' + theme + '/theme-' + colorScheme + '.css';

		replaceLink(themeLink, href);
		setComponentTheme(theme);
	}

	const replaceLink = (linkElement, href, callback) => {
		
		const id = linkElement.getAttribute('id');
		const cloneLinkElement = linkElement.cloneNode(true);

		cloneLinkElement.setAttribute('href', href);
		cloneLinkElement.setAttribute('id', id + '-clone');

		linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

		cloneLinkElement.addEventListener('load', () => {
			linkElement.remove();
			cloneLinkElement.setAttribute('id', id);

			if (callback) {
				callback();
			}
		});
	}

	switch (props.location.pathname) {
		case '/':
			return (initialValue != null) ? <Redirect to='/overview'  /> : <Route path="/" render={() => <Login colorScheme={colorScheme} />} />
		case '/error':
			return <Route path="/error" render={() => <Error colorScheme={colorScheme} />} />
		case '/notfound':
			return <Route path="/notfound" render={() => <NotFound colorScheme={colorScheme} />} />
		case '/access':
			return <Route path="/access" render={() => <Access colorScheme={colorScheme} />} />
		case '/certificates':
			return <Route path="/certificates" render={() => <Certificates colorScheme={colorScheme} />} />
		// default:
		// 	return <App colorScheme={colorScheme} onColorSchemeChange={onColorSchemeChange}
		// 		componentTheme={componentTheme} onComponentThemeChange={onComponentThemeChange}
		// 		theme={theme} onMenuThemeChange={onMenuThemeChange} />;

		default:
			return <permissionContext.Provider value={rolePermissions}>
				<App colorScheme={colorScheme} onColorSchemeChange={onColorSchemeChange}
				componentTheme={componentTheme} onComponentThemeChange={onComponentThemeChange}
				theme={theme} onMenuThemeChange={onMenuThemeChange} />
			</permissionContext.Provider>;

	}

}

export default withRouter(AppWrapper);